<template>
    <div class="container text-center">
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for doesn't exist.</p>
      <router-link to="/" class="btn btn-primary">Go to Home</router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: "NotFound",
  };
  </script>
  
  <style scoped>
  .container {
    padding: 20px;
  }
  </style>
  